import { render, staticRenderFns } from "./seminarsIndividualPanel.vue?vue&type=template&id=1a437e31&"
import script from "./seminarsIndividualPanel.vue?vue&type=script&lang=js&"
export * from "./seminarsIndividualPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports